import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "src/components/form/Input";
import Loader from "src/components/Loader";
import useEditProfile from "src/hooks/api/useEditProfile";
import useSearchAddress from "src/hooks/api/useSearchAddress";

interface EditAddressSmallProps {
	onDone?: () => void;
	renderButtons: (options?: {
		isSubmitting?: boolean;
		isValid?: boolean;
		onSubmit?: () => void;
	}) => any;
}

const EditAddressSmall = ({ onDone, renderButtons }: EditAddressSmallProps) => {
	const { t } = useTranslation("forms", {
		keyPrefix: "edit-address-small",
	});
	const [updateProfile, fetching] = useEditProfile();
	const [value, setValue] = useState({
		zipcode: "",
		house_number: "",
	});
	const { place, loading: loadingPlace } = useSearchAddress(value);

	const onSubmit = () => {
		updateProfile({
			address: {
				city: place?.city,
				street: place?.street,
				house_number: place?.house_number,
				house_number_extra: place?.house_number_extra,
				zipcode: place?.zipcode,
				country: "",
			},
		}).then(() => {
			if (onDone) {
				onDone();
			}
		});
	};

	return (
		<div className="flex flex-col flex-1">
			<div className="flex-1">
				<label className={`flex items-center text-[16px] mb-[4px]`}>
					<strong>{t("title")}</strong>
				</label>
				<div className="flex md:flex-row flex-col md:gap-4">
					<Input
						name="zipcode"
						className="flex-1"
						placeholder={t("zipcode")}
						value={value.zipcode}
						onChange={(key, value) =>
							setValue((v) => ({
								...v,
								[key]: value,
							}))
						}
					/>
					<Input
						name="house_number"
						className="md:max-w-[140px]"
						placeholder={t("house-number")}
						value={value.house_number}
						onChange={(key, value) =>
							setValue((v) => ({
								...v,
								[key]: value,
							}))
						}
					/>
				</div>
			</div>
			{place?.city && !loadingPlace && (
				<div className="flex justify-between items-center text-primary border-2 cursor-pointer rounded-md border-primary transition-all p-4 mt-4">
					<div className="flex flex-col">
						<strong>
							{place.street} {place.house_number}
							{place?.house_number_extra}
						</strong>
						<small>
							{place.zipcode}, {place.city}
						</small>
					</div>
					<div className="">
						<i className="fas fa-check"></i>
					</div>
				</div>
			)}
			{loadingPlace && (
				<div className="flex justify-between items-center text-primary border-2 cursor-pointer rounded-md border-primary transition-all p-4 mt-4">
					<Loader />
				</div>
			)}
			{renderButtons({
				isSubmitting: fetching,
				isValid: place?.street && place.city,
				onSubmit,
			})}
		</div>
	);
};

export default EditAddressSmall;
